import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-opposaiserviziispettivi-view',
  templateUrl: './form-opposaiserviziispettivi-view.component.html',
  styleUrls: ['./form-opposaiserviziispettivi-view.component.css']
})
export class FormOpposaiserviziispettiviViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
